import React, { Component } from 'react';
import { Formik } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import * as Yup from 'yup';
import { find } from 'lodash';
import * as constants from '../../constants';

import common from '../../../../common';
import core from '../../../core';


const { TextInput, SelectInput, NumberInput, DisplayFormikState } = core;

const FormItem = Form.Item;

const FormSchema = Yup.object().shape({
    name: Yup.string().required('*'),
    idCountry: Yup.number().integer().required('*'),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class RecipientForm extends Component {

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            await this.props.onSave(values);
            setSubmitting(false);
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'RecipientForm', key);
    }
    onCountryChanged = (id) => {
        let country = find(this.props.picklists.countries, { 'id': id });
        this.formik.setFieldValue('countryName',country.name);
        this.formik.setFieldValue('euOrAdequate',country.euOrAdequate);
    }

    CreateForm = (props) => {
        //console.log(props);
        const userHasReadonlyRights = false; //!this.props.currentUsersCompanyRights.includes(common.rights.BedrijfMuteren);

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                <TextInput {...props} name="name" readOnly={userHasReadonlyRights} label={this.label("Name")} formItemLayout={formItemLayout} />
                <SelectInput onSelectionChanged={this.onCountryChanged} {...props} name="idCountry" nameField="name" idField="id" items={this.props.picklists.countries} label={this.label("Country")} formItemLayout={formItemLayout} />

                <FormItem {...tailFormItemLayout}>
                    <Space.Compact className='entity-form-btns'>
                        <Button disabled={props.isSubmitting || userHasReadonlyRights} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || userHasReadonlyRights} > {this.label("Save")} </Button>
                    </Space.Compact>
                </FormItem>
                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true}
                initialValues={this.props.datacontext}
                validationSchema={FormSchema}
                onSubmit={this.onSave}
                render={this.CreateForm}
                innerRef={p => (this.formik = p)}
            />
        );
    }
}

export default RecipientForm